'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { Select, type SelectOption } from '@/components/storefront/ui/select';
import { useListingTransition } from '@/components/storefront/ListingTransitionContext';
import type { ListingSort } from '@/lib/storefront/products/listService';
const SORT_OPTIONS: {
  value: ListingSort;
  labelAr: string;
  labelEn: string;
}[] = [{
  value: 'random',
  labelAr: 'مختارات',
  labelEn: 'Featured'
}, {
  value: 'newest',
  labelAr: 'الأحدث',
  labelEn: 'Newest'
}, {
  value: 'price_asc',
  labelAr: 'السعر: من الأقل',
  labelEn: 'Price: Low to High'
}, {
  value: 'price_desc',
  labelAr: 'السعر: من الأعلى',
  labelEn: 'Price: High to Low'
}];
export default function SortDropdown(t0) {
  const $ = _c(14);
  const {
    locale,
    defaultSort
  } = t0;
  const searchParams = useSearchParams();
  const {
    navigateWithParams
  } = useListingTransition();
  const isRTL = locale === "ar";
  let t1;
  if ($[0] !== defaultSort || $[1] !== searchParams) {
    t1 = searchParams.get("sort") ?? defaultSort;
    $[0] = defaultSort;
    $[1] = searchParams;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const currentSort = t1;
  let t2;
  if ($[3] !== isRTL) {
    t2 = SORT_OPTIONS.map(opt => ({
      value: opt.value,
      label: isRTL ? opt.labelAr : opt.labelEn
    }));
    $[3] = isRTL;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const options = t2;
  let t3;
  if ($[5] !== defaultSort || $[6] !== navigateWithParams) {
    t3 = function handleChange(value) {
      navigateWithParams(params => {
        if (value === defaultSort) {
          params.delete("sort");
        } else {
          params.set("sort", value);
        }
      });
    };
    $[5] = defaultSort;
    $[6] = navigateWithParams;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleChange = t3;
  const t4 = isRTL ? "\u062A\u0631\u062A\u064A\u0628:" : "Sort:";
  const t5 = isRTL ? "\u062A\u0631\u062A\u064A\u0628 \u062D\u0633\u0628" : "Sort by";
  let t6;
  if ($[8] !== currentSort || $[9] !== handleChange || $[10] !== options || $[11] !== t4 || $[12] !== t5) {
    t6 = <Select value={currentSort} onChange={handleChange} options={options} prefix={t4} ariaLabel={t5} size="sm" className="min-w-[180px]" />;
    $[8] = currentSort;
    $[9] = handleChange;
    $[10] = options;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}